import React from 'react';
import { useLookAndFeelContext } from '@isyc-react/oncustomer/modules/objects/business-unit';
import { FooterContainer } from 'pods/footer';
import { useCristalImage } from 'common/utils/configuration-hook';
export const ContentBgLayout = props => {
    const { children } = props;
    const { logoDataUrl } = useLookAndFeelContext();
    const cristalImg = useCristalImage();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'background-layout-container' },
            React.createElement("header", null,
                React.createElement("div", { className: 'container text-center text-sm-center text-md-start align-items-center row p-0' },
                    React.createElement("div", { className: 'col p-0 text-start pb-2' },
                        React.createElement("a", { title: '' },
                            React.createElement("img", { src: logoDataUrl !== null && logoDataUrl !== void 0 ? logoDataUrl : undefined, className: 'img-fluid', draggable: false, "aria-label": '', "aria-describedby": '', alt: '', title: '' }))),
                    React.createElement("div", { className: 'col-lg-3 align-items-center d-flex justify-content-center' },
                        React.createElement("div", { className: 'd-flex flex-row text-center text-md-end mt-md-0' }, cristalImg && (React.createElement("img", { src: cristalImg !== null && cristalImg !== void 0 ? cristalImg : undefined, className: 'img-fluid', draggable: false, "aria-label": '', "aria-describedby": '', alt: '', title: '' })))))),
            React.createElement("main", { className: 'd-flex justify-content-center flex-column' },
                React.createElement("div", { className: 'm-5' }, children)),
            React.createElement(FooterContainer, null))));
};
